export * from './user-avatar.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/user-avatar/index.ts